import { KeyValuePair } from "../redux/types"

const GRAPH_REQUESTS:any = {
  USER: {
    scopes: ['User.Read']
  },
  API: {
    // For Car Designer APIs
    scopes: ['api://893879db-45d8-434c-a566-3fafc3bb4f29/API'],
  }
}

export async function getAPIHeaders({ msalApp, requireAuth, optionalAuth }:any) {
  if (requireAuth) {
    return getAuthHeaders(msalApp, GRAPH_REQUESTS.API)
  }

  // optionally attaching auth tokens for if logged in user so some actions can be personalized for specific users, for example logged-in users can rename the designs they have created later on.
  if (optionalAuth) {
    try {
      return await getAuthHeaders(msalApp, GRAPH_REQUESTS.API, { redirect: false })
    } catch (err) {
      // No logged in user, but it is optional so no need to do anything
    }
  }

  return {}
}

export async function getAuthHeaders(msalApp:any, scopes:any, options:any = {}) {
  const token = await acquireToken(msalApp, scopes, options.redirect)

  if (!token) return {}

  return {
    Authorization: `Bearer ${token.accessToken}`, // the token is a variable which holds the token
    'skip-user': 'true', // This header skips fetching the whole user in the server side.
  }
}

async function acquireToken(msalApp:any, request:any, redirect = true) {
  try {
    const token = await msalApp.acquireTokenSilent(request)
    if (!token) {
      throw new Error('No token')
    }

    return token
  } catch (err) {
    if (redirect) {
      console.error('Failed to get token silently', err)
      return msalApp.acquireTokenRedirect(request)
    } else {
      throw err
    }
  }
}

export function setDomainItem (domainData:KeyValuePair):KeyValuePair {
  // const hostname = "preview-cardesigner.kone.com"
  // const hostname = "cardesigner.kone.cn"
  const hostname = window.location.hostname
  let domainItem = domainData
  if (!domainItem) {
    throw Error('No matching domain in domain data')
  }

  // Setting the recaptcha value based on the domain.
  switch (domainItem.recaptcha) {
    case 3:
      domainItem.recaptchaSiteKey = "6LdMR74UAAAAABLIb3IWPMzDglEF__S6EeRhrto1" // DEV, localhost
      break
    case 5:
      domainItem.recaptchaSiteKey = "6Le6q7sUAAAAADG6n_80ikyFXbC5FLlWWWRFjJeQ" // DEV
      break
    case 6:
      domainItem.recaptchaSiteKey = "6Le6q7sUAAAAADG6n_80ikyFXbC5FLlWWWRFjJeQ" // QA
      break
    case 7:
      domainItem.recaptchaSiteKey = "6Le6q7sUAAAAADG6n_80ikyFXbC5FLlWWWRFjJeQ" // PROD
      break
    default:
      // China
      domainItem.recaptchaSiteKey = null
  }

  // testing for china case
  // domainItem.youtubeDisabled = true

  return domainItem
}